import { createAction } from 'redux-act';

/* Create Post */
const createPostRequest = createAction('CREATE_POST_REQUEST', data => data);
const createPostSuccess = createAction('CREATE_POST_SUCCESS', data => data);
const createPostError = createAction('CREATE_POST_ERROR');

/* Get Post All*/
const getAllPostRequest = createAction('GET_POST_ALL_REQUEST', data => data);
const getAllPostSuccess = createAction('GET_POST_ALL_SUCCESS', data => data);
const getAllPostError = createAction('GET_POST_ALL_ERROR');

/* Update Post */
const updatePostRequest = createAction('UPDATE_POST_REQUEST', data => data);
const updatePostSuccess = createAction('UPDATE_POST_SUCCESS', data => data);
const updatePostError = createAction('UPDATE_POST_ERROR');

/* Delete Post */
const deletePostRequest = createAction('DELETE_POST_REQUEST', data => data);
const deletePostSuccess = createAction('DELETE_POST_SUCCESS', data => data);
const deletePostError = createAction('DELETE_POST_ERROR');

/* post Like */
const postLikeRequest = createAction('POST_LIKE_REQUEST', data => data);
const postLikeSuccess = createAction('POST_LIKE_SUCCESS', data => data);
const postLikeError = createAction('POST_LIKE_ERROR');

/* post likes by id */
const postLikeByIdRequest = createAction('POST_LIKE_BY_ID_REQUEST', data => data);
const postLikeByIdSuccess = createAction('POST_LIKE_BY_ID_SUCCESS', data => data);
const postLikeByIdError = createAction('POST_LIKE_BY_ID_ERROR');

/* post Comment */
const postCommentRequest = createAction('POST_COMMENT_REQUEST', data => data);
const postCommentSuccess = createAction('POST_COMMENT_SUCCESS', data => data);
const postCommentError = createAction('POST_COMMENT_ERROR');

/* post Comment By Id */
const postCommentByIdRequest = createAction('POST_COMMENT_BY_ID_REQUEST', data => data);
const postCommentByIdSuccess = createAction('POST_COMMENT_BY_ID_SUCCESS', data => data);
const postCommentByIdError = createAction('POST_COMMENT_BY_ID_ERROR');

/* delete comment */
const deleteCommentRequest = createAction('DELETE_COMMENT_REQUEST', data => data);
const deleteCommentSuccess = createAction('DELETE_COMMENT_SUCCESS', data => data);
const deleteCommentError = createAction('DELETE_COMMENT_ERROR');

/* Update Comment */
const updateCommentRequest = createAction('UPDATE_COMMENT_REQUEST', data => data);
const updateCommentSuccess = createAction('UPDATE_COMMENT_SUCCESS', data => data);
const updateCommentError = createAction('UPDATE_COMMENT_ERROR');

/*  get Post  */
const getPostRequest = createAction('GET_POST_REQUEST', data => data);
const getPostSuccess = createAction('GET_POST_SUCCESS', data => data);
const getPostError = createAction('GET_POST_ERROR');

/*  get Post  counts */
const getPostCountsRequest = createAction('GET_POST_COUNTS_REQUEST', data => data);
const getPostCountsSuccess = createAction('GET_POST_COUNTS_SUCCESS', data => data);
const getPostCountsError = createAction('GET_POST_COUNTS_ERROR');


/*  get Post  counts */
const addAnnouncementRequest = createAction('ADD_ANNOUNCEMENT_REQUEST', data => data);
const addAnnouncementSuccess = createAction('ADD_ANNOUNCEMENT_SUCCESS', data => data);
const addAnnouncementError = createAction('ADD_ANNOUNCEMENT_ERROR');


/*  get Post  counts */
const getAnnouncementRequest = createAction('GET_ANNOUNCEMENT_REQUEST', data => data);
const getAnnouncementSuccess = createAction('GET_ANNOUNCEMENT_SUCCESS', data => data);
const getAnnouncementError = createAction('GET_ANNOUNCEMENT_ERROR');


// Update ANNOUNCEMENT action
const updateAnnouncementRequest = createAction('Update_ANNOUNCEMENT_REQUEST', data => data);
const updateAnnouncementSuccess = createAction('Update_ANNOUNCEMENT_SUCCESS', data => data);
const updateAnnouncementError = createAction('Update_ANNOUNCEMENT_ERROR');

// Delete ANNOUNCEMENT action
const deleteAnnouncementRequest = createAction('DELETE_ANNOUNCEMENT_REQUEST', data => data);
const deleteAnnouncementSuccess = createAction('DELETE_ANNOUNCEMENT_SUCCESS', data => data);
const deleteAnnouncementError = createAction('DELETE_ANNOUNCEMENT_ERROR');

// Get Pop Up Announcement  action
const getPopUpAnnouncementRequest = createAction('GET_POP_UP_ANNOUNCEMENT_REQUEST', data => data);
const getPopUpAnnouncementSuccess = createAction('GET_POP_UP_ANNOUNCEMENT_SUCCESS', data => data);
const getPopUpAnnouncementError = createAction('GET_POP_UP_ANNOUNCEMENT_ERROR');

// Get Webcast action
const getWebcastRequest = createAction('GET_WEBCAST_REQUEST', data => data);
const getWebcastSuccess = createAction('GET_WEBCAST_SUCCESS', data => data);
const getWebcastError = createAction('GET_WEBCAST_ERROR');

// Get All Announcement Action
const getAllAnnouncementRequest = createAction('GET_ALL_ANNOUNCEMENT_REQUEST', data => data);
const getAllAnnouncementSuccess = createAction('GET_ALL_ANNOUNCEMENT_SUCCESS', data => data);
const getAllAnnouncementError = createAction('GET_ALL_ANNOUNCEMENT_ERROR');


// Get All Announcement Action
const getAlertAnnouncementRequest = createAction('GET_ALERT_ANNOUNCEMENT_REQUEST', data => data);
const getAlertAnnouncementSuccess = createAction('GET_ALERT_ANNOUNCEMENT_SUCCESS', data => data);
const getAlertAnnouncementError = createAction('GET_ALERT_ANNOUNCEMENT_ERROR');



// clear existing data for constant
const handleClearCommunityStore = createAction('HANDLE_CLEAR_COMMUNITY_STORE', data => data);

export default {
    createPostRequest,
    createPostSuccess,
    createPostError,

    getAllPostRequest,
    getAllPostSuccess,
    getAllPostError,

    updatePostRequest,
    updatePostSuccess,
    updatePostError,

    deletePostRequest,
    deletePostSuccess,
    deletePostError,

    postLikeRequest,
    postLikeSuccess,
    postLikeError,

    postLikeByIdRequest,
    postLikeByIdSuccess,
    postLikeByIdError,

    postCommentRequest,
    postCommentSuccess,
    postCommentError,

    postCommentByIdRequest,
    postCommentByIdSuccess,
    postCommentByIdError,

    deleteCommentRequest,
    deleteCommentSuccess,
    deleteCommentError,

    updateCommentRequest,
    updateCommentSuccess,
    updateCommentError,

    getPostRequest,
    getPostSuccess,
    getPostError,

    getPostCountsRequest,
    getPostCountsSuccess,
    getPostCountsError,

    addAnnouncementRequest,
    addAnnouncementSuccess,
    addAnnouncementError,

    getAnnouncementRequest,
    getAnnouncementSuccess,
    getAnnouncementError,

    updateAnnouncementRequest,
    updateAnnouncementSuccess,
    updateAnnouncementError,

    deleteAnnouncementRequest,
    deleteAnnouncementSuccess,
    deleteAnnouncementError,

    getPopUpAnnouncementRequest,
    getPopUpAnnouncementSuccess,
    getPopUpAnnouncementError,

    getWebcastRequest,
    getWebcastSuccess,
    getWebcastError,

    getAllAnnouncementRequest,
    getAllAnnouncementSuccess,
    getAllAnnouncementError,

    getAlertAnnouncementRequest,
    getAlertAnnouncementSuccess,
    getAlertAnnouncementError,


    handleClearCommunityStore
};
